/** @file IK tool registration: title and activation chord I (viewport context). */
import type { ToolDef } from '../../stores/types';

/** Drags IK targets and creates IK from a click. */
export const tool: ToolDef = { id: 'ik', title: 'tools.ik.title', bindings: [{ id: 'tool.ik', keys: 'KeyI', context: 'viewport' }] };
